import React from 'react';

import { DesktopPredictionPanel } from './DesktopPredictionPanel';
import { MobilePredictionPanel } from './MobilePredictionPanel';
import { PredictionPanelProps } from './types';


export const PredictionPanel: React.FC<PredictionPanelProps> = ({ id, isDesktop }) => {
  if(isDesktop){
    return (
      <DesktopPredictionPanel id={id}/>
    );
  }
  return (
    <MobilePredictionPanel id={id} />
  );
};
